import 'src/styles/pages/fishPrice/rowTableFishPriceSkeleton.scss'

const RowTableFishPriceSkeleton = () => (
    <tr className="row-table-fish-price-skeleton">
        <td><div className="skeleton-box skeleton-1"></div></td>
        <td><div className="skeleton-box skeleton-2"></div></td>
        <td><div className="skeleton-box skeleton-3"></div></td>
        <td><div className="skeleton-box skeleton-4"></div></td>
        <td><div className="skeleton-box skeleton-5"></div></td>
        <td><div className="skeleton-box skeleton-6"></div></td>
        <td><div className="skeleton-box skeleton-7"></div></td>
    </tr>
)

export default RowTableFishPriceSkeleton